import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experiance from "./components/experiance/Experiance";
import Portfolio from "./components/portfolio/Portfolio";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div>
      <Header />
      <Nav />
      <About />
      <Experiance />
      <Portfolio />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
